<template>
  <div>
    <v-app-bar app color="white" :flat="true" height="60px">
      <!-- Display app nav icon only for md and below -->
      <v-app-bar-nav-icon
        class="d-flex d-lg-none"
        @click.stop="drawer = !drawer"
        v-if="$route.name != 'Login'"
      ></v-app-bar-nav-icon>

      <div class="d-flex align-center">
        <router-link :to="{name: 'Dashboard'}">
          <v-img
            v-if="$store.state.role == 'master'"
            alt="Vuetify Logo"
            class="mt-3 ml-2"
            contain
            src="../assets/klaspad-logo.png"
            transition="scale-transition"
            width="200"
          />
          <v-img
            v-else
            alt="Vuetify Logo"
            class="mt-1 ml-2"
            contain
            src="../assets/ism-logo.png"
            transition="scale-transition"
            width="100"
          />
        </router-link>
      </div>

      <v-spacer></v-spacer>

      <div class="text-center" v-if="!isLogin">
        <router-link :to="{name: 'CentreSignUp'}" style="text-decoration: none;">
          <v-btn target="_blank" text>
            <span class="mx-1">Sign Up</span>
          </v-btn>
        </router-link>
      </div>

      <div class="mx-3" style="opacity: 0.8;" v-if="!isLogin">or</div>

      <div class="text-center" v-if="!isLogin">
        <router-link :to="{name: 'Login'}" style="text-decoration: none;">
          <v-btn target="_blank" text>
            <span class="mx-1">Log In</span>
          </v-btn>
        </router-link>
      </div>

      <div class="text-center" v-if="isLogin">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn target="_blank" text v-bind="attrs" v-on="on">
              <v-icon size="20" color="#606060">mdi-translate</v-icon>
              <span class="ml-2">{{ languageDropdown }}</span>
              <v-icon size="20">mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in languages"
              :key="index"
              @click="onSwitchLang(item)"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="text-center" v-if="isLogin">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn target="_blank" text v-bind="attrs" v-on="on">
              <v-icon size="20" color="#606060">mdi-account</v-icon>
              <span class="ml-1">{{ $t('header.account') }}</span>
              <v-icon size="20">mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <router-link :to="{name: 'Profile'}" style="text-decoration: none;">
              <v-list-item @click="onCheckProfile()">
                <v-list-item-title>
                  <span class="mx-2">{{ $t('header.profile') }}</span>
                </v-list-item-title>
              </v-list-item>
            </router-link>
            <v-list-item ref="logoutBtn" @click="onLogout()">
              <v-list-item-title>
                <span class="mx-2">{{ $t('header.logout') }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-progress-linear
        :active="showProgress"
        :indeterminate="true"
        absolute
        bottom
        :height="3"
        class="primary-color"
      ></v-progress-linear>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-title>Foo</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Bar</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Fizz</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Buzz</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "Header",
  mounted: function () {
    this.isLogin = this.$store.state.jwt ? true : false;
  },
  data: () => ({
    refreshHeader: false,
    isLogin: null,
    drawer: false,
    group: null,
    languageDropdown: "English",
    languages: [
      { name: "English", value: "en" },
      { name: "简体中文", value: "zhHans" },
      { name: "한국어", value: "ko" },
    ],
  }),
  computed: {
    showProgress: function () {
      return this.$store.state.progressStatus;
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
    isLogin: function (newValue) {
      this.isLogin = newValue;
    },
  },
  methods: {
    onLogout: function () {
      localStorage.clear();
      this.$router.push({ name: "Login" });
      this.$store.commit("updateJwt", null);
    },
    onSwitchLang(lang) {
      this.$i18n.locale = lang.value;
      this.languageDropdown = lang.name;
    },
  },
};
</script>

<style scoped>
</style>